import { axios } from "./http.js";

export const addCategory = params => {
  return axios.post("/product/category/add", params);
};
export const getCategoryList = params =>
  axios.post("/product/category/list", params);

export const deleteCategory = id => {
  return axios.delete(`/product/category/${id}`);
};

export const putCategory = params => {
  return axios.put(`/product/category/${params.id}`, params);
};
export const getCategory = id => axios.get(`/product/category/${id}`);
